import e, { memo as c } from "react";
import { Box as o, Breadcrumb as n } from "@chakra-ui/react";
import { Crumb as s } from "./crumb.js";
const b = ["singular"], d = c(
  ({ breadcrumbItems: a, buttonClickHandler: m, variant: r }) => /* @__PURE__ */ e.createElement(o, { className: "breadcrumb-container" }, /* @__PURE__ */ e.createElement(
    n,
    {
      spacing: 0,
      __css: {
        ">ol": {
          flexWrap: "wrap"
        }
      },
      variant: r
    },
    a.map((t) => /* @__PURE__ */ e.createElement(
      s,
      {
        element: t,
        buttonClickHandler: m,
        "data-testid": "breadcrumb-item",
        key: t.text,
        variant: r
      }
    ))
  ))
);
export {
  d as Breadcrumbs,
  b as variants
};
